import { useTranslation } from 'react-i18next';

import CustomAlert from '../../../UiComponentsLibrary/CustomAlert';

import { ApiError } from '../../interfaces/ApiError';

import { ErrorTooltip } from '../ErrorTooltip';

interface ErrorDisplayProps {
  error: ApiError;
  customMessage?: string;
}

export const ErrorDisplay = (props: ErrorDisplayProps) => {
  const { error, customMessage } = props;
  const { t } = useTranslation();

  const customErrorMessage =
    Number(error.statusCode) === 403
      ? `Error: ${t('role-based-access-blocked-message')}`
      : customMessage || `Error: ${t('api-error-message')}`;

  const shouldShowTooltip =
    customMessage &&
    error.message &&
    error.message.trim() !== '' &&
    customMessage !== error.message;

  return (
    <CustomAlert alertMessage={customErrorMessage} variant="error">
      {shouldShowTooltip && <ErrorTooltip message={error.message} />}
    </CustomAlert>
  );
};
